import * as React from 'react';
// mui
import {
  Alert,
  Button,
  Card,
  Grid,
  Snackbar,
  Typography,
  Box,
  TextField
} from '@mui/material';
// router
import { useNavigate, useSearchParams } from 'react-router';
// axios
import api from '../../axios';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  
  const [ searchParams ] = useSearchParams();
  const [ newPassword, setNewPassword ] = React.useState('');
  const [ passwordError, setPasswordError ] = React.useState<string>('');
  const [ isLoading, setIsLoading ] = React.useState(false);
  const [ showSnackbar, setShowSnackbar ] = React.useState(false);
  const token = searchParams.get('token');

  const handleContinueButtonClick = (e: any) => {
    e.preventDefault();

    if (newPassword.length < 4) {
      setPasswordError('Password must be longer than 4 characters!');
      return;
    } else {
      setPasswordError('');
    }

    setIsLoading(true);
    if (token) {
      api.post(`/auth/reset?token=${token}`, {
        password: newPassword,
      })
        .then((res) => {
          console.log(res);
          navigate('/auth');
        })
        .catch((err) => {
          console.log(err);
          setShowSnackbar(true);
        })
        .finally(() => setIsLoading(false));
    } else {
      setShowSnackbar(true);
      setIsLoading(false)
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: (theme) =>
          `linear-gradient(to bottom right, 
        ${theme.palette.primary.main}44 0%, 
        ${theme.palette.background.default}FF 100%)`
      }}
    >
      <Grid container sx={{ p: 4 }} spacing={4}>
        <Grid size={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="calc(100vh - 64px)"
          >
            <Card sx={{ width: 500, p: 3 }}>
              <Typography variant='h6'>Reset Password</Typography>
              <Typography>Please enter your new password.</Typography>
              <TextField
                value={newPassword}
                onChange={(e) => { setNewPassword(e.target.value); }}
                required
                fullWidth
                error={!!passwordError}
                helperText={passwordError}
                id="outlined-password-input"
                label="Password"
                type="password"
              />
              <Button loading={isLoading} fullWidth variant='contained' onClick={handleContinueButtonClick}>Reset Password</Button>
            </Card>
          </Box>
        </Grid>

        <Snackbar
          open={showSnackbar}
          autoHideDuration={6000}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
        >
          <Alert
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
          >
            There was an error with resetting your password!
          </Alert>
        </Snackbar>
      </Grid>
    </Box>
  )
}
